<template>
  <!-- layout -->
  <div class="grid min-h-screen grid-cols-[1fr_auto_1fr] grid-rows-[auto_1fr_auto] max-w-screen">
    <!-- header -->
    <header
      class="sticky top-0 z-50 col-span-3 grid h-fit items-center gap-5 px-4 py-8 text-white grid-cols-[auto_auto_1fr] md:grid-cols-[1fr_1fr_1fr] bg-tertiary">
      <div>
        <RouterLink class="flex items-center" :to="userIsLoggedIn ? '/dashboard' : '/'">
          <OtivoLogo class="h-7 md:h-10 w-auto pl-4" />
          <div v-if="showPartnerLogo" class="border-l ml-4 pl-4 md:ml-8 md:pl-8 py-1">
            <img :src="PartnerLogo" alt="Partner Logo" class="h-7 md:h-10 w-auto" />
          </div>
        </RouterLink>
      </div>
      <nav class="flex grow items-center justify-center gap-10">
        <RouterView name="headerNav"></RouterView>
      </nav>
      <nav id="right-nav" class="flex justify-end gap-5">
        <RouterView name="actions"></RouterView>
      </nav>
    </header>

    <!-- body section -->
    <main class="col-span-3 grid h-fit min-h-full w-full grow max-w-screen">
      <!-- content -->
      <Transition mode="out-in" name="fade">
        <RouterView class="max-w-screen" />
      </Transition>
      <!-- ./content -->
    </main>

    <!-- footer -->
    <footer class="col-span-full h-fit bg-tertiary text-blue-2">
      <BaseSection>
        <RouterView name="footerNav"></RouterView>
        <div class="w-full text-center">
          <p class="text-center text-sm">
            <LicensingDetails />
          </p>
        </div>
      </BaseSection>
    </footer>
  </div>
</template>

<script lang="ts" setup>
import OtivoLogo from '@/components/SVGS/BrandIcons/OtivoLogo.svg'
import BaseSection from '@/app/components/BaseSection.vue'
import { computed, provide, ref } from 'vue'
import { useAdviserPages } from '@/composables/useAdviserPages'
import { useUserStore } from '@/store/pinia/UserStore.ts'
import LicensingDetails from '@/app/components/common/LicensingDetails.vue'

const menuOpen = ref(false)
const userIsLoggedIn = computed(() => !!useUserStore().getUser?.account_id ?? false)
const { PartnerLogo, showPartnerLogo } = useAdviserPages()

provide('headerNavOpen', menuOpen)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
